import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { IUserInfo } from '../interfaces/user.interface';

import { HttpBaseApi } from './base-http.api';

@Injectable({ providedIn: 'root' })
export class UserApi extends HttpBaseApi {
  private readonly _httpClient = inject(HttpClient);
  private readonly _endpoint = 'users';

  public getInfoByToken(): Observable<IUserInfo> {
    return this._httpClient.get<IUserInfo>(this.buildUrl(`${this._endpoint}/info/by-token`));
  }
}
